import EDHttp from '../utils/EDHttp';
import fileDownload from "js-file-download";
export default
    {
        getList: function (query = '')
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.get(`/admin/administrators/all${query}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }, error => reject(error)).catch(error => reject(error))
            })
        },
        load: function (page = 0)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.get(`/admin/administrators/${page}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }, error => reject(error)).catch(error => reject(error))
            })
        },
        add: function (account)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.post('/admin/administrators/create', account).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }, error => reject(error)).catch(error => reject(error))

            })
        },
        delete: async function (id)
        {
            try
            {
                const { data: result } = await EDHttp.delete(`/admin/administrators/${id}`)
                return result.data;
            } catch (error)
            {
                throw error.response.data.message;
            }
        },
        get: function (id)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.get(`/admin/administrator/${id}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }, error => reject(error)).catch(error => reject(error))
            })
        },
        update: async function (id, account)
        {
            try
            {
                const response = await EDHttp.put(`/admin/administrators/update/${id}`, account)
                return response.data.data
            } catch (error)
            {
                throw error.response.data
            }
        },
        reset: function (id)
        {
            return new Promise((resolve, reject) =>
            {
                EDHttp.put(`/admin/administrator/reset-password/${id}`).then(result =>
                {
                    if (result && !result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                }, error => reject(error)).catch(error => reject(error))

            })
        },
        downloadReport: async function (filename)
        {
            const response = await EDHttp.get(`/crm/report?file=${filename}`)
            fileDownload(response.data, filename);
            return true
        },
        getAdminAssignedUsers: async function (adminId)
        {
            try
            {
                const { data: result } = await EDHttp.get(`/admin/${adminId}/users`)
                return result.data;
            } catch (error)
            {
                throw error.response.data.message;
            }
        },
        bulkAssignUsers: async function (payload)
        {
            try
            {
                const { data: result } = await EDHttp.post(`/admin/bulk/assign/users`, payload)
                return result.data;
            } catch (error)
            {
                throw error.response.data.message;
            }
        },
        bulkAssignDomains: async function (payload)
        {
            try
            {
                const { data: result } = await EDHttp.put(`/admin/bulk/assign/domains`, payload)
                return result.data;
            } catch (error)
            {
                throw error.response.data;
            }
        },
        downloadCfpUsers: async function (query = '')
        {
            try
            {
                const response = await EDHttp.downloadReport(`/admin/cfp/users${query}`);
                fileDownload(response.data, "cfp_users.csv");
            } catch (error)
            {
                throw new Error("No record found")
            }
        },
        userForgiveness: async function (userId)
        {
            try
            {
                const response = await EDHttp.get(`/admin/user/forgiveness/${userId}`)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        loansOutOfDefault: async function (userId)
        {
            try
            {
                const response = await EDHttp.get(`/admin/user/loans-out-of-default/${userId}`)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        addForgiveness: async function (userId, payload)
        {
            try
            {
                const response = await EDHttp.post(`/admin/user/forgiveness/${userId}`, payload)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        updateForgiveness: async function (userId, forgivenessId, payload)
        {
            try
            {
                const response = await EDHttp.put(`/admin/user/forgiveness/${userId}/${forgivenessId}`, payload)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        bulkArchiveUsers: async function (payload)
        {
            try
            {
                const response = await EDHttp.post(`/admin/bulk/archive`, payload)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        deleteMSD: async function (userId, msdId)
        {
            try
            {
                const result = await EDHttp.delete(`/admin/user/${userId}/msd/${msdId}`);
                return result.data.data;
            } catch (error)
            {
                throw error.response.data.message;
            }
        },
        createLoanOutOfDefault: async function (payload)
        {
            try
            {
                const response = await EDHttp.post(`/admin/user/add-loan-out-of-default`, payload)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        editLoanOutOfDefault: async function (payload, outOfDefaultId)
        {
            try
            {
                const response = await EDHttp.put(`/admin/user/edit-loan-out-of-default/${outOfDefaultId}`, payload)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        toggleChatbotGlobally: async function (enabled)
        {
            try
            {
                const response = await EDHttp.put(`/admin/chatbot/toggle-all`, { enabled })
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
        getChatbotConfiguration: async function ()
        {
            try
            {
                const response = await EDHttp.get(`/admin/chatbot/configuration`)
                return response.data.data
            } catch (error)
            {
                throw new Error(error.response.data.message)
            }
        },
    }